import { CountType, InsightViewOption, MeasureType } from 'enums'
import { CountTypeStrings } from 'enums/CountType'
import { InsightViewOptionStrings } from 'enums/InsightViewOption'
import { InsightData } from 'schemas/action/InsightDataSchema'
import i18n from 'i18n'

import messageUtil from 'utils/messageUtil'
import AccordionSectionType, { AccordionSectionTypeStrings } from '../enum/AccordionSectionType'

export const getMeasureTypeByCountType = (countType: CountTypeStrings) => {
  switch (countType) {
    case CountType.MENTIONS:
      return MeasureType.MENTIONS
    case CountType.AUTHORS:
      return MeasureType.UNIQUE_AUTHORS
    case CountType.POSTS:
    default:
      return MeasureType.POSTS
  }
}

export const getSelectionName = (insight: InsightData, viewOption?: InsightViewOptionStrings) => {
  switch (viewOption) {
    case InsightViewOption.AUTHORS:
    case InsightViewOption.MOST_MENTIONS:
    case InsightViewOption.MOST_FOLLOWERS:
    case InsightViewOption.MOST_ENGAGEMENT:
      return insight.authorName ? insight.authorName : insight.name

    case InsightViewOption.POSITIVE_NEGATIVE:
    case InsightViewOption.POSITIVE_NEGATIVE_NEUTRAL:
      return (insight.name && messageUtil.sentiments(insight.name)) || insight.name

    default:
      return insight.name
  }
}

export const getInsightContentTypeDisplayText = (
  insightContentType: AccordionSectionTypeStrings
) => {
  switch (insightContentType) {
    case AccordionSectionType.SOUND_BITE:
      return i18n.t('soundBite_other')
    case AccordionSectionType.COMMENT:
      return i18n.t('comment_other')
    case AccordionSectionType.DOMAIN:
      return i18n.t('domain_other')
    case AccordionSectionType.TOP_AUTHOR:
      return i18n.t('topAuthor_other')
    case AccordionSectionType.SUMMARY:
      return i18n.t('metricOverview')
    default:
      return ''
  }
}

export const getPercentOfTotal = (current: number, total: number) => {
  if (current !== undefined && total !== undefined) {
    if (current && total > 0) {
      const percentage = (current / total) * 100
      const roundedPercentage = Math.round(percentage * 100) / 100

      if (roundedPercentage < 1) {
        return '<1'
      }

      return `${roundedPercentage.toFixed(0)}`
    }
    return '0'
  }
  return undefined
}
